import React from "react";
import { useSpinnerContext, useSessionContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import Credentials from "./credentials";
import PropTypes from 'prop-types';

const SetupCredentials = ({ initial, success }) => {

    const { setSpinnerShow } = useSpinnerContext();
    const { session, setSession } = useSessionContext();

    const { email } = initial;

    const handleSubmit = async (values) => {

        setSpinnerShow(true);
        try {
            await sunboundPayProxy.updatePassword(values.password);
            setSession({ ...session, hasPassword: true });
            success();
        } catch (error) {
            // setFormState(`Unable to process your request, please contact ${Constants.Help.Email} for support`);
            console.error(error);
        }
        setSpinnerShow(false);
    };

    return (
        <>
            <Credentials submit={handleSubmit} initial={{ email }}>
                <h1 className="page-header">Create a password to start</h1>
            </Credentials>
        </>
    );

};

SetupCredentials.propTypes = {
    initial: PropTypes.object,
    success: PropTypes.func
};

export default SetupCredentials;